export var EQuestionType;
(function (EQuestionType) {
    EQuestionType["Boolean"] = "Boolean";
    EQuestionType["Select"] = "Select";
    EQuestionType["MultiSelect"] = "MultiSelect";
    EQuestionType["Picture"] = "Picture";
    EQuestionType["Multiple"] = "Multiple";
    EQuestionType["LeadGeneration"] = "LeadGeneration";
    EQuestionType["Email"] = "Email";
    EQuestionType["Name"] = "Name";
    EQuestionType["PostalCode"] = "PostalCode";
    EQuestionType["TextField"] = "TextField";
    EQuestionType["Number"] = "Number";
    EQuestionType["Date"] = "Date";
})(EQuestionType || (EQuestionType = {}));
export var EFieldType;
(function (EFieldType) {
    EFieldType["Email"] = "Email";
    EFieldType["PhoneNumber"] = "PhoneNumber";
    EFieldType["Address"] = "Address";
    EFieldType["TextBox"] = "TextBox";
    EFieldType["Checkbox"] = "Checkbox";
    EFieldType["Dropdown"] = "Dropdown";
    EFieldType["DatePicker"] = "DatePicker";
    EFieldType["TimePicker"] = "TimePicker";
    EFieldType["CompanyName"] = "CompanyName";
    EFieldType["CompanyURL"] = "CompanyURL";
    EFieldType["FirstName"] = "FirstName";
    EFieldType["LastName"] = "LastName";
    EFieldType["Textarea"] = "Textarea";
    EFieldType["Discount"] = "Discount";
})(EFieldType || (EFieldType = {}));
export var ECallToActionType;
(function (ECallToActionType) {
    ECallToActionType["Email"] = "Email";
    ECallToActionType["Phone"] = "Phone";
    ECallToActionType["URL"] = "URL";
    ECallToActionType["ViewDetails"] = "ViewDetails";
    ECallToActionType["Video"] = "Video";
    ECallToActionType["Payment"] = "Payment";
    ECallToActionType["Schedule"] = "Schedule";
    ECallToActionType["Redirect"] = "Redirect";
})(ECallToActionType || (ECallToActionType = {}));
export var EAnswerTypes;
(function (EAnswerTypes) {
    EAnswerTypes["FirstName"] = "First Name";
    EAnswerTypes["LastName"] = "Last Name";
    EAnswerTypes["Email"] = "Email";
    EAnswerTypes["TextField"] = "Text";
    EAnswerTypes["Number"] = "Phone";
    EAnswerTypes["PostalCode"] = "Postal code";
    EAnswerTypes["Boolean"] = "Radio Button";
    EAnswerTypes["Select"] = "Drop Down";
})(EAnswerTypes || (EAnswerTypes = {}));
